exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component-terms-scrollwrap .bounce{animation:scrollwrap-bounce 5s ease-in-out infinite}@keyframes scrollwrap-bounce{0%{transform:translateY(0)}10%{transform:translateY(5px)}20%{transform:translateY(-5px)}30%{transform:translateY(5px)}40%{transform:translateY(0)}to{transform:translateY(0)}}", ""]);

// exports
